<template>
	<div></div>
</template>
<script>
export default {
	props: [],
	name: "Add",
	data() {
		return {};
	},
	mounted() {},
	methods: {},
};
</script>
